import React from 'react';

/**
 * DwepServiceIcon Icon - Used in serviceSplit page
 */
export const DwepServiceIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
      <path
        d="M3.19824 11.5C3.19824 12.5609 3.5833 13.5783 4.2687 14.3284C4.9541 15.0786 5.8837 15.5 6.853 15.5"
        stroke="#212121"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.1981 8.5C5.02548 6.27067 5.93917 4.604 5.93917 3.5C5.93917 2.70435 5.65038 1.94129 5.13633 1.37868C4.62228 0.81607 3.92508 0.5 3.1981 0.5C2.47113 0.5 1.77392 0.81607 1.25987 1.37868C0.745822 1.94129 0.457031 2.70435 0.457031 3.5C0.457031 4.60533 1.37072 6.272 3.1981 8.5Z"
        stroke="#212121"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5073 10C11.2642 10 11.8778 9.32843 11.8778 8.5C11.8778 7.67157 11.2642 7 10.5073 7C9.75033 7 9.13672 7.67157 9.13672 8.5C9.13672 9.32843 9.75033 10 10.5073 10Z"
        fill="#212121"
      />
      <path
        d="M3.19787 4.5C3.70249 4.5 4.11156 4.05228 4.11156 3.5C4.11156 2.94772 3.70249 2.5 3.19787 2.5C2.69325 2.5 2.28418 2.94772 2.28418 3.5C2.28418 4.05228 2.69325 4.5 3.19787 4.5Z"
        fill="#212121"
      />
      <path
        d="M10.5073 15C12.9438 12.14 14.1621 9.97333 14.1621 8.5C14.1621 7.43913 13.777 6.42172 13.0916 5.67157C12.4062 4.92143 11.4766 4.5 10.5073 4.5C9.538 4.5 8.60839 4.92143 7.92299 5.67157C7.23759 6.42172 6.85254 7.43913 6.85254 8.5C6.85254 9.97333 8.07079 12.14 10.5073 15Z"
        stroke="#212121"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default DwepServiceIcon;
